import React from 'react';

const NotFound = () => (
  <div id="page">
    <h1>Page Not Found</h1>
  </div>
);

export default NotFound;
